
import CryptoJS from 'crypto-js'
import { AppConfig } from '../AppConfig';
import * as Logger from 'js-logger';
import { getFetch } from './fetch'

export default function HideAndSeek({ url }) {

  if (AppConfig.cryPng) {
    return getFromUrl(url);
  } else {
    return prepareUrl(url);
  }
}

/**
 * strange hack
 * @param url
 * @returns {Promise.<TResult>}
 */
function prepareUrl(url) {
  let prom = new Promise(function (resolve, reject) {
    setTimeout(() => {
      // переведёт промис в состояние fulfilled с результатом "result"
      resolve("result");
    }, 1);
    return url;
  });

  return prom.then(result => {
    Logger.get('prepareUrl').log(url);
    return url;
  });
}

function getFromUrl(url) {
  url = url + "&seek=1";
  // Logger.get('HideAndSeek').log("encrypted Image url start " ,  url);
  return getFetch(url)
    .then(({ data }) => {
      let decrypted = JSON.parse(
        CryptoJS.AES.decrypt(
          data.enc,
          "CiIGel4lcYizF05QGNx39fnFJ79Dg8Qh9mMaiPViv3jiXylZfJwnmuiplglB33MS",
          { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8)
      );
      // Logger.get('HideAndSeek').log("encrypted Image url finish " ,  url);

      return decrypted;
    });
}

const CryptoJSAesJson = {
  stringify: function (cipherParams) {
    let j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    let j = JSON.parse(jsonStr);
    let cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  }
};



// WEBPACK FOOTER //
// ./src/tools/hide-and-seek.js